module.exports = __webpack_public_path__ + "img/logo.05591a6d.png";